import dbClient from './client.js'

const auth = {}

auth.name = "auth"

auth.clear = async () => {
  // Clear in local storage
  if (typeof localStorage !== "undefined") {
    localStorage.removeItem("jwt")
    localStorage.removeItem("user")
  }

  // Clear in IDB
  var db = await dbClient.open()
  let store = db.transaction(auth.name, "readwrite").objectStore(auth.name)
  return store.clear()
}

auth.set = async (data) => {
  if (!data) {
    return auth.clear()
  }

  // Set in local storage
  if (typeof localStorage !== "undefined") {
    localStorage.setItem("jwt", data.token)
    localStorage.setItem("user", JSON.stringify(data.user))
  }

  // Set in IDB
  data.id = "current" // There should only ever be one entry in the auth database
  var db = await dbClient.open()
  let store = db.transaction(auth.name, "readwrite").objectStore(auth.name)
  return store.put(data)
}

auth.getUser = () => {
  if (typeof localStorage === "undefined") {
    throw new Error("cannot get user, did you mean auth.getUserAsync()?")
  }
  const userStr = localStorage.getItem("user")
  return userStr ? JSON.parse(userStr) : null
}

auth.getJwt = () => {
  if (typeof localStorage === "undefined") {
    throw new Error("cannot get jwt, did you mean auth.getJwtAsync()?")
  }
  return localStorage.getItem("jwt")
}

auth.getLocationId = () => {
  return auth.getUser()?.location_id
}

auth.isAdmin = () => {
  return auth.getUser()?.role === "admin"
}

auth.getUserAsync = async () => {
  var db = await dbClient.open()
  let store = db.transaction(auth.name).objectStore(auth.name)
  const data = await store.get("current")
  return data?.user
}

auth.getJwtAsync = async () => {
  var db = await dbClient.open()
  let store = db.transaction(auth.name).objectStore(auth.name)
  const data = await store.get("current")
  return data?.token
}

auth.getLocationIdAsync = async () => {
  var db = await dbClient.open()
  let store = db.transaction(auth.name).objectStore(auth.name)
  const data = await store.get("current")
  return data?.user?.location_id
}

auth.isAdminAsync = async () => {
  var db = await dbClient.open()
  let store = db.transaction(auth.name).objectStore(auth.name)
  const data = await store.get("current")
  return data?.user?.role === "admin"
}

export default auth